































import {Component, Vue} from "vue-property-decorator";
import {PriceListStore} from "@/modules/pricelists/store";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import PriceListTableAction from "@/modules/pricelists/List/components/TableAction.vue";
import PriceListSearch from "@/modules/pricelists/List/components/Search.vue";
import {PriceListParams} from "@/modules/pricelists/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

const columns = [
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        scopedSlots: {customRender: 'action'},
        align: 'center',
        width: 100
    },
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50
    },
    {
        title: "Mã BG",
        dataIndex: "code",
        key: "code",
        width: 120,
        ellipsis: true
    },
    {
        title: "Tên BG",
        dataIndex: "name",
        key: "name",
        width: 150,
        ellipsis: true
    },
    {
        title: "Phụ phí nhiên liệu",
        dataIndex: "fuelRate",
        key: "fuelRate",
        width: 150,
        ellipsis: true
    },
    {
        title: "Phụ phí vùng xa",
        dataIndex: "regionFarRate",
        key: "regionFarRate",
        width: 150,
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        scopedSlots: {customRender: 'status'},
        width: 120
    }
];

@Component({
    name: "PriceListList",
    components: {PriceListSearch, PriceListTableAction, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = columns;

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...columns,
                {
                    title: "Bưu cục áp dụng",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    width: 150,
                    ellipsis: true
                } as any
            ];
        }
        PriceListStore.listPriceList({ params: new PriceListParams() });
    }

    get priceLists() {
        return PriceListStore.loadedIds.map((id: number) => PriceListStore.data[id]);
    }

    get pagination() {
        return {
            current: PriceListStore.meta.page,
            pageSize: PriceListStore.meta.limit,
            total: PriceListStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bảng giá`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        PriceListStore.listPriceList({params: {...PriceListStore.params, page: pagination.current, limit: pagination.pageSize}});
    }
}
